<template>
  <b-card no-body class="bg-white mt-10 border-b4b4b4">
    <h2 class="bg-primary text-white font-bold text-lg p-3 rounded-t-lg">
      Course Overview
    </h2>

    <div class="rounded-lg cust-overflow-y-primary-color p-8">
      <!-- <div
        class="items-center cursor-pointer pt-1"
        v-for="(item, index) in courseObject"
        :key="'item -' + index"
      >
        <div
          v-b-toggle.collapse-1
          class="
            cardbody-p
            border-2
            rounded-lg
            px-2
            py-3
            transition
            duration-200
            ease-in-out
            transform
            hover:scale-105
          "
        >
          
          <div class="flex items-center w-full">
            <div class="width5">
              <feather-icon
                icon="ChevronDownIcon"
                class="cursor-pointer w-3 h-3"
                v-if="!isCollapseVisible"
              ></feather-icon>
              <feather-icon
                icon="ChevronUpIcon"
                class="cursor-pointer w-3 h-3"
                v-else
              ></feather-icon>
            </div>
            <div class="my-auto width55">
              <p
                class="
                  font-semibold
                  lg:text-lg
                  md:text-lg
                  text-md
                  px-4
                  items-center
                  truncate
                "
              >
                {{ item.name }}
              </p>
            </div>
            <div
              class="w-1/2 font-thin text-right text-mute pr-2 text-sm my-auto"
            >
              00hr 15min
            </div>
          </div>
          <b-collapse :id="'collapse-' + index" class="bg-white mt-2 w-full">
            <div class="w-full items-center cursor-pointer rounded-sm">
              <div
                class="ml-2 flex justify-between"
                v-for="(item, index) in item.chapters"
                :key="'item -' + index"
              >
                <div class="flex items-baseline pt-2">
                  <div class="mr-2 my-auto">
                    <feather-icon
                      icon="PlayCircleIcon"
                      class="cursor-pointer playicon-cust"
                    ></feather-icon>
                  </div>
                  <div>
                    <p class="font-semibold text-md">
                      {{ item }}
                    </p>
                  </div>
                </div>
                <div class="font-thin text-right pr-2 text-sm my-auto">
                  04:25
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div> -->
      <div class="accordion" role="tablist">
        <div no-body class="">
          <div v-if="chapterByCourseId.length > 0">
            <div
              class="items-center cursor-pointer pt-1"
              v-for="(item, index) in chapterByCourseId"
              :key="'item -' + index"
              role="tab"
            >
              <div
                v-b-toggle="'accordion-' + index"
                class="cardbody-p border-2 rounded-lg px-2 py-3"
                @click="getChapterId(item._id)"
              >
                <div class="flex items-center w-full">
                  <div class="width5">
                    <feather-icon
                      icon="ChevronDownIcon"
                      class="cursor-pointer w-3 h-3"
                      v-if="!isCollapseVisible"
                    ></feather-icon>
                    <feather-icon
                      icon="ChevronUpIcon"
                      class="cursor-pointer w-3 h-3"
                      v-else
                    ></feather-icon>
                  </div>
                  <div class="my-auto width55">
                    <p
                      class="font-semibold text-md text-black px-4 items-center truncate"
                    >
                      {{ item.name }}
                    </p>
                  </div>
                </div>

                <b-collapse
                  :id="'accordion-' + index"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <!-- <b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text> -->
                    <b-card-text>
                      <div
                        class="w-full items-center cursor-pointer rounded-sm"
                        v-if="item.topic.length"
                      >
                        <div
                          class="ml-2 flex justify-between"
                          v-for="(items, index) in topicByChapterId"
                          :key="'item -' + index"
                        >
                          <div
                            class="flex items-baseline pt-2"
                            @click="getChapterId(item._id)"
                          >
                            <div class="mr-2 my-auto">
                              <feather-icon
                                v-if="items.docType == 'video'"
                                icon="PlayCircleIcon"
                                class="font-semibold cursor-pointer icon18px text-black"
                              >
                              </feather-icon>
                              <feather-icon
                                v-else
                                icon="FileIcon"
                                class="font-semibold cursor-pointer icon18px text-black"
                              >
                              </feather-icon>
                            </div>
                            <div>
                              <p class="font-semibold text-md">
                                {{ items.name }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="" v-if="item.embedded.length != 0">
                        <div
                          class="flex items-center px-6 py-3"
                          v-for="(emb, index) in item.embedded"
                          :key="index"
                        >
                          <div class="my-auto">
                            <feather-icon
                              icon="GlobeIcon"
                              class="font-semibold icon18px text-black"
                            >
                            </feather-icon>
                          </div>

                          <div
                            class="text-sm mx-3 my-auto font-medium"
                            @click="handleLink(emb)"
                          >
                            {{ emb.name }}
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </div>
            </div>
          </div>
          <div v-else>Comming Soon...</div>
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleClickcheckout(name) {
      this.$router.push({ name: name });
    },
  },
  data() {
    return {
      isCollapseVisible: false,
      content: [
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "00.11",
        },
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "01.15",
        },
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "02.45",
        },
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "04.29",
        },
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "05.32",
        },
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "06.21",
        },
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "02.45",
        },
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "04.29",
        },
        {
          module: "Etiam molestie eget tellus quis rhoncus",
          time: "05.32",
        },
      ],
      icontitle: [
        {
          img: require("@/assets/images/customer-view/time.png"),
          title: "4 Weeks",
        },
        {
          img: require("@/assets/images/customer-view/eng1.png"),
          title: "English",
        },
        {
          img: require("@/assets/images/customer-view/scr.png"),
          title: "Access on Mobile & TV",
        },
        {
          img: require("@/assets/images/customer-view/fold1.png"),
          title: "Downloadable Resources",
        },
        {
          img: require("@/assets/images/customer-view/document.png"),
          title: "Certificate of completion",
        },
      ],
      courseIndex: [
        {
          module: "introduction",
        },
        {
          module: "intro1",
        },
        {
          module: "introduction",
        },
        {
          module: "intro1",
        },
      ],
      courseChapter: [
        {
          chapter: "hello world programme",
        },
        {
          chapter: "print even Number",
        },
        {
          chapter: "Palindrome code",
        },
        {
          chapter: "odd number",
        },
      ],
      courseObject: [
        {
          name: "Course Introduction",
          chapters: [
            "hello world programme",
            "print even Number",
            "Palindrome code",
            "odd numbeee",
          ],
          showCollapse: false,
        },
        {
          name: "Python Setup",
          chapters: [
            "Course Introduction",
            " Why Python ?",
            "Course Curriculum Overview",
            "Course FAQs",
          ],
          // time: ["02.12", "03.25", "05.18", "10.08"],
          showCollapse: false,
        },
        {
          name: "Python Object and Data Structure Basics",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
        {
          name: "Python Statements",
          chapters: [
            "Numbers: Simple Arithmetic",
            " Variable Assignments",
            "Introduction to Strings",
            "Indexing and Slicing with Strings",
          ],
          showCollapse: false,
        },
        {
          name: "String Properties and Methods",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
        {
          name: "Lists in Python",
          chapters: [
            "Command Line Basics",
            " Running Python Code",
            "Getting the Notebooks and the Course Material",
            "Git and Github Overview (Optional)",
          ],
        },
        {
          name: "Dictionaries in Python",
        },
        {
          name: "Tuples with Python",
        },
        {
          name: "Booleans in Python",
        },
        {
          name: "Comparison Operators in Python",
        },
        {
          name: "Logical Operators",
        },
      ],
    };
  },
  components: {},
  methods: {
    async getChapterByCourseId() {
      const { data } = await this.$store.dispatch(
        "eLearning/getChapterByCourseId",
        {
          id: this.selectedCourseHome._id,
        }
      );
      // console.log(data);
      // console.log(this.selectedCourseHome._id);
      this.$store.commit("eLearning/getChapterByCourseId", data);
    },
    async getChapterId(_id) {
      const { data } = await this.$store.dispatch(
        "eLearning/getTopicByChapterId",
        { _id }
      );
      // console.log(data);
      this.$store.commit("eLearning/getTopicByChapterId", data);
      // console.log(data);
    },

    handleLink(linkdata) {
      // if (linkdata.url.includes("http")) {
      //   window.open(linkdata.url, "_blank");
      // } else {
      //   window.open("https://" + linkdata.url, "_blank");
      // }
    },
  },
  mounted() {
    this.getChapterByCourseId();
  },
  computed: {
    ...mapState("eLearning", ["selectedCourseHome"]),
    ...mapState("eLearning", ["chapterByCourseId"]),
    ...mapState("eLearning", ["topicByChapterId"]),
  },

  // methods() {
  //   switchCollapse() {

  //   }
  // }
};
</script>
